import React , { Component ,useState,useEffect} from 'react';
import HeaderBannerSty from './headerBanner.module.css';
import {withRouter} from 'react-router';
import classNames from 'classnames';


const HeaderBanner = (props)=>{
    // const {match} =props;
    // let bannerAnima=null;
    
    // useEffect(() => {
    //     alert(match)
    //     bannerAnima=HeaderBannerSty.bannerAnimation;
    // },[match])

    return(
        <div className={`${HeaderBannerSty.headerBannerDiv} ${HeaderBannerSty.bannerAnimation}`}>
            
        </div>

    );
}

export default withRouter(HeaderBanner);